//
// Utilities to support react-router params via react context
// Heavily inspired by react-router's withRouter() functionality
//
import React from 'react';
import PropTypes from 'prop-types';
import hoistStatics from 'hoist-non-react-statics';

const getDisplayName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Component';

// HoC to extract react-router params from context
// This function will generate a wrapper component which extracts
// react-router's `params` from the react context and applies is as
// a prop to the wrapped component.
export function withParams(WrappedComponent) {
  const WithParams = (props, { params }) => React.createElement(WrappedComponent, { ...props, params });
  WithParams.contextTypes = { params: PropTypes.shape({}) };
  WithParams.displayName = `withParams(${getDisplayName(WrappedComponent)})`;
  WithParams.WrappedComponent = WrappedComponent;
  return hoistStatics(WithParams, WrappedComponent);
}

// HoC to export react-router params to context
// This function will generate a wrapper component that exports
// the `params` prop into the react child context.
export function exportingParams(WrappedComponent) {
  class ExportingParams extends React.Component {
    getChildContext() {
      const { params } = this.props;
      return { params };
    }

    render() {
      return React.createElement(WrappedComponent, this.props);
    }
  }
  ExportingParams.propTypes = { params: PropTypes.shape({}).isRequired };
  // eslint-disable-next-line react/forbid-prop-types
  ExportingParams.childContextTypes = { params: PropTypes.object };
  ExportingParams.displayName = `reportingParams(${getDisplayName(WrappedComponent)})`;
  ExportingParams.WrappedComponent = WrappedComponent;
  return hoistStatics(ExportingParams, WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/util/params_context.js